import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarConfig from "../../../components/OnBoarding_OffBoarding/sidebar_On_Off_Boarding";

import OnBoarding from "../../../images/onBoarding.png";
import OffBoarding from "../../../images/offBoarding.png";

const AdminOnOffBoarding = () => {
  const userRoles = useSelector((store) => store.auth.userRoles);

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="jumbotron">
            <h2 className="font-weight-bold">
              Configuración de OnBoarding / OffBoarding
            </h2>
            <hr className="my-4" />
            <p className="mb-4">
              Desde aquí podrás administrar todas las configuraciones
              correspondientes a OnBoarding y OffBoarding, a continuación te
              mostramos algunos accesos rápidos para que puedas comenzar
            </p>
            <Row>
              {userRoles.length > 0 && userRoles.includes("administrador") && (
                <>
                  <Col>
                    <h4 className="mb-3">Crear WorkFlows</h4>
                    <Link
                      className="btn btn-primary btn-lg"
                      to="/workflow"
                      role="button"
                    >
                      WorkFlows
                    </Link>
                  </Col>
                  <Col>
                    <h5 className="d-flex flex-wrap justify-content-start align-items-center">
                      <img
                        src={OnBoarding}
                        alt="Imagen OnBoarding"
                        width="30x"
                        height="30x"
                        style={{ marginRight: "0.5rem" }}
                      ></img>
                      OnBoarding
                    </h5>
                    {/* <ul className="ml-3 p-0">
                      {userRoles.length > 0 &&
                      userRoles.includes("administrador") ? (
                        <li>
                          <Link to="/workflow">Mantenimiento de WorkFlows</Link>
                        </li>
                      ) : null}
                    </ul> */}
                    <ul className="mt-2 ml-3 p-0">
                      {userRoles.length > 0 &&
                      userRoles.includes("administrador") ? (
                        <li>
                          <Link to="/Mantenimiento-Bienvenida">
                            Mantenimiento de Bienvenida
                          </Link>
                        </li>
                      ) : null}
                    </ul>
                  </Col>
                </>
              )}
              {/* <Col>
                <h5 className="d-flex flex-wrap justify-content-start align-items-center">
                  <img
                    src={OffBoarding}
                    alt="Imagen OffBoarding"
                    width="30x"
                    height="30x"
                    style={{ marginRight: "0.5rem" }}
                  ></img>
                  OffBoarding
                </h5>
                <ul className="mt-2 ml-3 p-0">
                  {userRoles.length > 0 &&
                  (userRoles.includes("Responsable_Sanciones") ||
                    userRoles.includes("administrador")) ? (
                    <>
                      <li>
                        <Link to="/categorias-desvinculación">
                          Categoría de desvinculación
                        </Link>
                      </li>
                      <li>
                        <Link to="/motivo-acciones-disciplinarias">
                          Motivo Disciplinario
                        </Link>
                      </li>
                      <li>
                        <Link to="/tipos-acciones-disciplinarias">
                          Tipos de acciones
                        </Link>
                      </li>
                      <li>
                        <Link to="/medidas-disciplinarias">
                          Medidas disciplinarias
                        </Link>
                      </li>
                      <li>
                        <Link to="/tipo-falta">Tipo de falta</Link>
                      </li>
                      <li>
                        <Link to="/sansiones-estatus">Estatus</Link>
                      </li>
                      <li>
                        <Link to="/sansiones-formatos/1">Formatos</Link>
                      </li>
                    </>
                  ) : null}
                  {userRoles.length > 0 &&
                    (userRoles.includes("Responsable_Sanciones") ||
                      userRoles.includes("Encargado_Sanciones") ||
                      userRoles.includes("administrador") ||
                      userRoles.includes("jefe")) && (
                      <li>
                        <Link to="/casos-disciplinarios">
                          Casos Disciplinarios
                        </Link>
                      </li>
                    )}
                  {userRoles.length > 0 &&
                  (userRoles.includes("Encargado_Sanciones") ||
                    userRoles.includes("administrador") ||
                    userRoles.includes("jefe")) ? (
                    <>
                      <li>
                        <Link to="/acciones-disciplinarias">
                          Acciones Disciplinarias
                        </Link>
                      </li>
                    </>
                  ) : null}
                </ul>
              </Col> */}
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminOnOffBoarding;
